import {
  BrandPowerStations,
  PowerStation,
  PowerStationInternal,
} from "../types/products";
import { buildProductRecord } from "../utils/products";

const brand = "Pecron";
const rawData: PowerStationInternal[] = [
  // Low DC
  {
    name: "F3000LFP",
    amazon: {
      href: "https://www.amazon.com/dp/B0F6YCRKTJ/",
      affiliate: "https://amzn.to/429s2P0",
    },
    img: "/images/products/pecron/f3000lfp/front-left.webp",

    price: 899,
    capacity: 3072,
    acOutput: 3600,
    dcOutput: 10,
    solar: 1600,
    expandable: true,

    displayPowerSystemsPage: true,
  },
  {
    name: "E2000LFP",
    amazon: {
      href: "https://www.amazon.com/dp/B0FYPM6JM7",
      affiliate: "https://link.amazon/B07Avp77O",
    },
    img: "/images/products/pecron/e2000lfp/front-left.webp",

    price: 599,
    capacity: 1920,
    acOutput: 2000,
    dcOutput: 10,
    solar: 600,
    solar2: 100,
    expandable: true,

    displayPowerSystemsPage: true,
  },
  {
    name: "F1000LFP",
    amazon: {
      href: "https://www.amazon.com/dp/B0GJ92B5SQ/",
      affiliate: "https://amzn.to/4vwP5Re",
    },
    img: "/images/products/pecron/f1000lfp/front-left.webp",

    price: 329,
    capacity: 1004,
    acOutput: 1500,
    dcOutput: 10,
    solar: 600,

    displayPowerSystemsPage: true,
  },

  // Mid DC
  // {
  //   name: "E1000LFP",
  //   amazon: {
  //     href: "https://www.amazon.com/dp/B0FN7RL92D/",
  //     affiliate: "https://amzn.to/3QaclV8",
  //   },
  //   img: "https://www.pecron.com/cdn/shop/files/1500x1500_2.jpg?v=1774515696&width=900",

  //   price: 369,
  //   capacity: 1024,
  //   acOutput: 1800,
  //   dcOutput: 20,
  //   solar: 600,

  //   expandable: true,
  // },
  // {
  //   name: "F5000LFP",
  //   amazon: {
  //     href: "https://www.amazon.com/dp/B0GVMSFTXX/",
  //     affiliate: "https://amzn.to/4mxWZ9d",
  //   },
  //   img: "https://www.pecron.com/cdn/shop/files/1500x1500_1_9537becd-c4c3-4e5c-956c-4e36e75a7a5f.jpg?v=1774603927&width=900",

  //   price: 1999,
  //   capacity: 5120,
  //   acOutput: 3600,
  //   dcOutput: 25,
  //   solar: 3200,
  //   solar2: 3200,
  //   expandable: true,
  // },

  // High DC
  // 30A:
  // https://www.pecron.com/collections/power-station/products/pecron-e3800lfp-portable-power-station-4200w-3840wh?variant=45804485083324
  {
    name: "E3600LFP",
    amazon: {
      href: "https://www.amazon.com/dp/B0D83QYRDS/",
      affiliate: "https://amzn.to/3O7xQFA",
    },
    img: "/images/products/pecron/e3600lfp/front.webp",

    price: 1049,
    capacity: 3072,
    acOutput: 3600,
    dcOutput: 30,
    solar: 1200,
    solar2: 1200,
    solar3: 150,
    expandable: true,

    displayPowerSystemsPage: true,
  },
  {
    name: "E1500LFP",
    amazon: {
      href: "https://www.amazon.com/dp/B0CKWTHM8K/",
      affiliate: "https://amzn.to/4svLWOT",
    },
    img: "/images/products/pecron/e1500lfp/front-left.webp",

    price: 549,
    capacity: 1536,
    acOutput: 2200,
    dcOutput: 30,
    solar: 700,
    solar2: 100,
    expandable: true,

    displayPowerSystemsPage: true,
  },
  {
    name: "E2400LFP",
    amazon: {
      href: "https://www.amazon.com/dp/B0HLYX5VC8/",
      affiliate: "https://link.amazon/B01IWsAi9",
    },
    img: "/images/products/pecron/e2400lfp/front-left.webp",

    price: 649,
    capacity: 2048,
    acOutput: 2400,
    dcOutput: 30,
    solar: 700,
    solar2: 100,

    displayPowerSystemsPage: true,
  },
];

const powerStations: BrandPowerStations = {
  name: brand,
  powerStations: buildProductRecord<PowerStationInternal, PowerStation>(
    rawData,
    brand
  ),
};

export default powerStations;
